import axios from "axios";
// import jwtDecode from "jwt-decode";
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useRef, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { CardBody, Col, Row } from "reactstrap";
import {
  getPricingPlansById,
  logEvent, loginUser, getEnvFileData,
  getRoleAccess,
  getGBussinessInfo
} from "../services/apiServices.js";
// import logImg from "./../components/images/GymLogo.png";
import logImg from "./../components/images/Easy-MembrLogo.png";
import logBg from "./../components/images/loginBg.png";
import PageError from "./PageError.js";
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBIcon, MDBToast } from "mdb-react-ui-kit";
import { useAnalytics } from "../hooks/useAnalytics.js";
import { useAccess } from "../context/AccessContext.js";

const Login = ({ setToken }) => {
  console.log("Rendering Login component");
  const { trackButtonClick } = useAnalytics();
  const userRef = useRef();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const planId = params.get('id');
  const emailSend = params.get('value');
  const [emailSent, setEmailSent] = useState(emailSend == "true" ? true : false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState(false);
  const [domain, setDomain] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  // const CLIENT_ID =
  //   "102702637040-eau4e3o86jeoorqtveosi9fggnkduc7j.apps.googleusercontent.com";
  const navigate = useNavigate();
  const hostname = window.location.hostname;
  let subdomain = "";
  console.log(hostname, 'hostname');

  if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
    const parts = hostname.split('.');
    if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
      subdomain = parts[0];
    }
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const domain = urlObj.hostname;
    setDomain(domain)
  }, []);


  // useEffect(() => {
  //   if(localStorage.getItem("redirectmemberportal") && domain){
  //     const memberInfo = JSON.parse(localStorage.getItem("redirectmemberportal"));
  //     if(memberInfo && memberInfo.relocate){
  //       window.location.href = window.location.origin+ "/sessions/"
  //     }
  //   }
  // }, [domain]);

  // useEffect(() => {
  //   if (localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("loggedUserInfo")) {
  //     const memberInfo = JSON.parse(localStorage.getItem("loggedMemberInfo"));
  //     if (memberInfo && memberInfo.navigate) {
  //       window.location.href = window.location.origin + "/sessions/"
  //     }
  //   }
  // }, []);

  useEffect(() => {
    userRef.current.focus();
  }, [navigate]);

  const handleReload = () => {
    window.location.reload();
  }
  useEffect(() => {
    setError("");
  }, [username, password]);


  const fetchEnvData = async () => {
    try {
      const response = await getEnvFileData();

      if (response.ok) {
        const data = await response.json();
        console.log("Environment Data:", data);

        if (data && data.length > 0) {
          const firstEnvData = data[0];
          localStorage.setItem("frontEndEnvData", JSON.stringify(firstEnvData));
        } else {
          console.error("No data received from API or empty array");
        }
      } else {
        console.error("Failed to fetch environment data:", response.statusText);
      }
    } catch (e) {
      console.error("Error fetching environment data:", e);
    }
  };

  const { fetchAccess, classFetchAccess } = useAccess();
  function setUserSession(userInfo) {
    // fetchAccess(userInfo);
    localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));

  }
  // const [roleAccess, setRoleAccess] = useState(null)
  async function fetchAccessInfo(userInfo) {
    try {
      // const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
      if (!userInfo?.rolevalues) {
        // setLoading(false);
        return;
      }

      const response = await getRoleAccess("easymembr", userInfo.rolevalues);
      if (!response || response === "false") {
        // setLoading(false);
        return;
      }

      const recinfo = await response.json();
      if (recinfo) {
        console.log(recinfo, 'recinfo');
        return recinfo?.access
        // setRoleAccess(recinfo?.access);
      }
    } catch (err) {
      console.error("Error fetching access:", err);
    } finally {
      // setLoading(false);
    }
  }







  const applyLoginErrorMessage = (jOBj) => {
    const msg = jOBj?.errorr ?? jOBj?.error ?? "";
    if (msg && String(msg).includes("Suspended")) {
      setError("This Gym account was Suspended!");
    } else if (msg && String(msg).includes("Deleted")) {
      setError("This Gym account was deleted!");
    } else if (msg && String(msg).includes("Unable") && String(msg).includes("staff")) {
      setError("Unable to login for the staff.");
    } else if (msg && String(msg).includes("Unable") && String(msg).includes("admin")) {
      setError("Unable to login for the admin.");
    } else {
      setError("Invalid Username/password");
    }
  };

  const submitHandler = async (e, credentials) => {
    if (e) e.preventDefault();
    if (isLoggingIn) return;
    setIsLoggingIn(true);
    let jOBj = null;
    let httpLoginOk = false;
    try {
      const userInfo = credentials
        ? await loginUser(credentials)
        : await loginUser({ username, password });

      console.log(userInfo, "userInfo");
      if (!userInfo || userInfo === "false") {
        setApiError(true);
        return;
      }

      try {
        jOBj = await userInfo.json();
      } catch (parseErr) {
        console.error("Login response JSON parse failed:", parseErr);
        setError("Invalid Username/password");
        return;
      }
      console.log(jOBj);

      if (userInfo.status !== 200) {
        console.log("Login failed, status:", userInfo.status, jOBj);
        applyLoginErrorMessage(jOBj);
        return;
      }

      httpLoginOk = true;
      console.log(jOBj.userInfo);
      if (!credentials) {
        setWithExpiry("username", username, 0);
        setWithExpiry("password", password, 0);
      }
      setUserSession(jOBj.userInfo);
      const access = await fetchAccessInfo(jOBj.userInfo);
      fetchAccess();
      classFetchAccess();
      afterLogin(jOBj, access);
      setToken(jOBj.token);
      fetchEnvData();
      trackButtonClick("Login", "Staff_Login", "staff", {});
    } catch (err) {
      console.error("Login error:", err);
      if (httpLoginOk) {
        setError("Something went wrong after login. Please try again.");
      } else {
        applyLoginErrorMessage(jOBj);
      }
    } finally {
      setIsLoggingIn(false);
    }
  };
  let pagePath = "/dashboard";
  async function afterLogin(jOBj, access) {
    let gymid = jOBj.userInfo.gymid;
    const response = await getPricingPlansById(gymid);
    const recinfo = await response.json();
    console.log(recinfo)

    if (recinfo && (recinfo !== null)) {
      localStorage.setItem("planInfo", JSON.stringify(recinfo));
      if (!recinfo?.feature?.dashboard) {
        pagePath = "/bInfo"
      }
    }
    if (planId) {
      pagePath = `/billingmanagementplans?id=${planId}`;
    }
    localStorage.removeItem("username");
    localStorage.removeItem("password");
    console.log(access, 'roleAccessroleAccessroleAccessroleAccessroleAccess');

    if (pagePath == "/dashboard") {
      if ((access?.dashboard?.access == false)) {
        pagePath = "/mmanager"
      }
    }

    console.log("111111111", jOBj)

    const redirectedToVerification = await checkAndRedirectToVerification(jOBj?.userInfo);
    console.log("redirectedToVerification", redirectedToVerification)



    if (!redirectedToVerification) {
      navigate(pagePath);
    }



    try {

      const frontEndEnvData = localStorage.getItem("frontEndEnvData");
      const googleMapsApiKeydata = frontEndEnvData ? JSON.parse(frontEndEnvData)?.reactappipaddressurl : "https://api.ipify.org?format=json";

      const url = googleMapsApiKeydata
      const res = await axios.get(url);
      console.log(res.data.ip);
      localStorage.setItem('ipaddress', res.data.ip);
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
    let ip = localStorage.getItem("ipaddress") || "--";
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let Eventtype = "login";
    let flag = "Login Successfull";
    let username1 = jOBj.userInfo.email;
    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
  }


  const checkAndRedirectToVerification = async (userInfo) => {
    try {
      const response = await getGBussinessInfo(userInfo.gymid);
      if (!response || response === "false") return false;

      const businessInfo = await response.json();
      console.log("Businessinfo:", businessInfo);
      const emailVerifiedStatus = businessInfo?.isemailverified;

      if (emailVerifiedStatus === false || emailVerifiedStatus === "false" || emailVerifiedStatus === 0 || emailVerifiedStatus === "0") {

        const businessEmail = businessInfo?.businessEmail || userInfo.email;
        const verificationUrl = `/verify/email?email=${encodeURIComponent(businessEmail)}&business=${encodeURIComponent(userInfo?.gymname)}&gymId=${encodeURIComponent(userInfo?.gymid)}&staffId=${encodeURIComponent(userInfo?._id)}`;

        console.log("navurl", verificationUrl)
        // Update userInfo with business email
        // userInfo.businessEmail = businessEmail;
        // userInfo.email = businessEmail;
        // localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));

        // Navigate to verification page
        navigate(verificationUrl);
        return true;
      }
      return false; // Email is verified, continue to dashboard
    } catch (error) {
      console.error("Error checking email verification:", error);
      return false;
    }
  };




  useEffect(() => {
    let tsesson = false;
    async function fetchData() {
      try {
        if (JSON.parse(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo"))._id) {
          console.log(JSON.parse(localStorage.getItem("loggedUserInfo"))._id);
          tsesson = true;
        }
      } catch (e) {
        console.log("errore ::::::::::::::: " + e);
      }

      if (tsesson) {
        if (localStorage.getItem("loggedUserInfo")) {
          let gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
          const response = await getPricingPlansById(gymid);
          const recinfo = await response.json();
          if (!recinfo || recinfo == "false") {
            return;
          }
          if (recinfo && (recinfo !== null)) {
            localStorage.setItem("planInfo", JSON.stringify(recinfo));
          }
        }
        const access = await fetchAccessInfo(JSON.parse(localStorage.getItem("loggedUserInfo")));
        if (access?.dashboard?.access) {
          navigate("/dashboard");
        } else {
          navigate("/mmanager")
        }

      } else {
        // Only auto-login if user is not currently logging in and credentials exist
        if (!isLoggingIn && (localStorage.getItem("username") || localStorage.getItem("password"))) {
          console.log(localStorage.getItem("username"));
          console.log(JSON.parse(localStorage.getItem("username")));

          setUsername(JSON.parse(localStorage.getItem("username")).value);
          setPassword(JSON.parse(localStorage.getItem("password")).value);

          let credentials = {
            username: JSON.parse(localStorage.getItem("username")).value,
            password: JSON.parse(localStorage.getItem("password")).value,
          };
          console.log(credentials);
          submitHandler(null, credentials);
        }
        else {
          /**
           * Session error handling!
           */
          if (localStorage.getItem("SError")) {
            setError(localStorage.getItem("SError"));
            setTimeout(() => {
              setError("");
              localStorage.removeItem("SError");
            }, 5000);
          }
        }
      }
    }
    fetchData();
  }, []);

  function setWithExpiry(key, value, expiration) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + expiration,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function responseGmail(resp) {
    console.log("response from gmail..");
    console.log(resp);
    submitHandler(null, {
      ...jwtDecode(resp.credential),
      username: jwtDecode(resp.credential).email,
      loginsource: "Google",
      password: "d3fault",
    });
  }



  try {
    useEffect(() => {

      try {
        let CLIENT_ID = "68288337026-6p3096b5r2ukcpvbvggtrgsinp72eegd.apps.googleusercontent.com";
        if (domain == "easymembr.zencruz.com" || domain == "easymembr-beta.zencruz.com") {

          CLIENT_ID = "102702637040-eau4e3o86jeoorqtveosi9fggnkduc7j.apps.googleusercontent.com";
        } else if (domain == "www.easymembr.com" || domain == "easymembr.com" || domain == "app.easymembr.com" || domain == "beta.easymembr.com" || domain == `${subdomain}.easymembr.com`) {
          // const frontEndEnvData = localStorage.getItem("frontEndEnvData");
          // console.log(frontEndEnvData, '99999999999999');

          CLIENT_ID = "102702637040-5o3s1v3v4dv3vndpo3pr3r3tic04npq1.apps.googleusercontent.com"
        }

        /* global google*/
        google.accounts.id.initialize({
          client_id: CLIENT_ID + "",
          callback: responseGmail,
        });
        google.accounts.id.renderButton(document.getElementById("signinDiv"), {
          theme: "outline",
          size: "large",
        });
      } catch (e) { }
    }, [domain]);
  } catch (e) { }


  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  return (
    <React.Fragment>
      <div className="back-to-home">
        <Link to="/">
          <MDBBtn>
            <MDBIcon fas icon="arrow-left" />
          </MDBBtn>
        </Link>
      </div>
      {/* Hero Start */}
      {apiError ? <PageError handleReload={handleReload} /> : <section className="cover-user bg-white">
        <div className="container-fluid px-0">
          <Row className="g-0 position-relative">
            <Col lg={4} className="cover-my-30 ">
              <div className="cover-user-img d-flex">
                <Row className="w-100">
                  <div className="col-12">
                    <div className="d-flex flex-column auth-hero">
                      <div className="my-md-5 text-center">
                        <Link to="/" >
                          <img src={logImg} className="gymlogo1 mt-md-5" alt="" />
                        </Link>
                      </div>
                      <MDBCard className="border border-success w-100">
                        <MDBCardBody>
                          <MDBCardTitle>Login </MDBCardTitle>
                          <div className="title-heading mt-0 my-lg-auto">
                            <div
                              className="login-page border-0 p-0"
                              style={{ zIndex: 1 }}
                            >
                              <CardBody className="p-0">
                                {/* <h4 className="card-title">Login</h4> */}
                                <form
                                  onSubmit={submitHandler}
                                  className="login-form mt-4"
                                >
                                  <div style={{ color: "red" }}>{error}</div>

                                  <Row>
                                    <Col lg={12}>
                                      <div className="mb-3">
                                        <label className="form-label">
                                          Email /Mobile Number
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Email / Mobile Number."
                                          name="number"
                                          value={username}
                                          ref={userRef}
                                          onChange={(e) =>
                                            setUsername(e.target.value)
                                          }
                                          required
                                        />
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div className="mb-3">
                                        <label className="form-label">
                                          Password{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="IconContainer">
                                          <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Password"
                                            onChange={(e) =>
                                              setPassword(e.target.value)
                                            }
                                            value={password}
                                            required
                                          />
                                          <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} />

                                        </div>
                                      </div>
                                    </Col>

                                    <Col lg={12}>
                                      <div className="d-flex justify-content-between">
                                        <div className="mb-3">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            placeholder="Remember me"
                                            value="Remember me"
                                            id="flexCheckDefault"
                                          />
                                          <label className="form-check-label">
                                            Remember me
                                          </label>
                                        </div>
                                        {/* <p className="forgot-pass mb-0"><Link to="/auth-reset-password" className="fw-bold px-0 ps-1 text-primary">Forgot password?</Link></p> */}
                                      </div>
                                    </Col>
                                  </Row>

                                  <div className="mb-3">
                                    <div
                                      id="signinDiv"
                                      className="google-email"
                                    ></div>
                                  </div>
                                  <div className="col-lg-12 mb-0">
                                    <div className="d-grid">
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                      >
                                        Login
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </CardBody>
                              <div className="col-12">
                                <p className="mb-0 mt-3">
                                  <span className="text-dark me-2 font-14px">
                                    Don't have an account ?
                                  </span>
                                  <Link
                                    to="/commercials"
                                    className="fw-bold px-0 ps-1 fs-6 text-primary"
                                  >
                                    Signup
                                  </Link>
                                  <p className="mb-0 mt-3">
                                    <Link
                                      to="/getresetPassword"
                                      className="fw-bold px-0 fs-6 text-primary"
                                    >Forgot password?
                                    </Link>
                                  </p>
                                </p>
                              </div>
                            </div>
                          </div>
                        </MDBCardBody>
                      </MDBCard>
                      <div className="footer mb-md-5 text-center">
                        <p className="mt-2 text-muted">
                          © {new Date().getFullYear()} Zencruz.
                        </p>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </Col>
            <div
              className="col-lg-8  padding-less img"
              style={{ backgroundImage: `url(${logBg})` }}
              data-jarallax='{"speed": 0.5}'
            >
              <div className="greenoverlay"></div>
            </div>
          </Row>
        </div>
      </section>}
      {emailSent &&
        <>
          <MDBAlert
            color="primary"
            autohide
            position='top-right'
            delay={5000}
            appendToBody
            open={emailSent}
            onClose={() => { setEmailSent(false) }}
          >
            <h6>We've sent your login credentials to your registered email address.<br /> Please check your inbox to log in your account.</h6>
          </MDBAlert>
        </>
      }
      {/* end section */}
    </React.Fragment>
  );
};
export default Login;
